/**
 * EVSS 3D Viewer ↔ YMQ Bridge
 * Dieses Script verbindet YMQ Option-Auswahl mit dem 3D Viewer Iframe.
 * Einfach als Custom JS im Shopify Theme einbinden (nur auf der Konfigurator-Produktseite).
 */

(function () {
  'use strict';

  // ── Viewer Iframe ──────────────────────────────────────────────────────────
  const VIEWER_URL = 'https://www.evss.at/konfi/';

  // Farbmapping: YMQ Option-Label → Hex
  const COLOR_MAP = {
    'Schwarz':               '#1a1a1a',
    'Schwarz (Eloxiert)':    '#1a1a1a',
    'schwarz Edelstahl':     '#1a1a1a',
    'Silber':                '#c0c0c0',
    'Silber Edelstahl':      '#c0c0c0',
    'Silber Nickel':         '#c0c0c0',
    'Gold':                  '#d4a017',
    'Gold (Eloxiert)':       '#d4a017',
    'Blau':                  '#1e40af',
    'Blau (Eloxiert)':       '#1e40af',
    'Rot':                   '#dc2626',
    'Rot (Eloxiert)':        '#dc2626',
    'Orange':                '#e65100',
    'Orange (Eloxiert)':     '#e65100',
    'Lila':                  '#7c3aed',
    'Lila (Eloxiert)':       '#7c3aed',
    'Weiß':                  '#f5f5f5',
    'Weiß (Eloxiert)':       '#f5f5f5',
    'Titanium (Eloxiert)':   '#8a9ba8',
    'Arctic Blue (Eloxiert)':'#7dd3fc',
  };

  function getHex(label) {
    if (!label) return '#1a1a1a';
    // Exact match
    if (COLOR_MAP[label]) return COLOR_MAP[label];
    // Partial match
    for (const [key, hex] of Object.entries(COLOR_MAP)) {
      if (label.toLowerCase().includes(key.toLowerCase())) return hex;
    }
    return '#1a1a1a';
  }

  // ── Iframe erstellen & einbinden ───────────────────────────────────────────
  let viewerFrame = null;
  let viewerReady = false;
  const msgBuffer = [];

  function createViewer() {
    // Prüfen ob Viewer schon existiert
    if (document.getElementById('evss-3d-viewer')) return;

    // Container suchen — nach YMQ Optionen einfügen
    const target = document.querySelector('.ymq-option-container, .product-form, form[action="/cart/add"]');
    if (!target) return;

    const wrap = document.createElement('div');
    wrap.id = 'evss-3d-viewer-wrap';
    wrap.style.cssText = 'width:100%;max-width:600px;margin:0 auto 24px;aspect-ratio:16/9;border-radius:8px;overflow:hidden;background:#111;';

    viewerFrame = document.createElement('iframe');
    viewerFrame.id = 'evss-3d-viewer';
    viewerFrame.src = VIEWER_URL;
    viewerFrame.style.cssText = 'width:100%;height:100%;border:none;';
    viewerFrame.allow = 'accelerometer; gyroscope';

    wrap.appendChild(viewerFrame);
    target.parentNode.insertBefore(wrap, target);

    window.addEventListener('message', onViewerMsg);
  }

  function onViewerMsg(e) {
    const d = e.data;
    if (!d || !d.type) return;
    if (d.type === 'VIEWER_READY' || d.type === 'EVSS_ACK') {
      viewerReady = true;
      flushBuffer();
    }
  }

  function sendToViewer(type, payload) {
    const msg = { type, payload };
    if (!viewerReady || !viewerFrame) {
      msgBuffer.push(msg);
      return;
    }
    try {
      viewerFrame.contentWindow.postMessage(msg, '*');
    } catch(e) {}
  }

  function flushBuffer() {
    while (msgBuffer.length) {
      try { viewerFrame.contentWindow.postMessage(msgBuffer.shift(), '*'); } catch(e) {}
    }
  }

  // ── YMQ Events abfangen ────────────────────────────────────────────────────
  // YMQ feuert ein Custom Event oder ändert die DOM-Klassen beim Klick
  // Wir beobachten beide Methoden

  function handleOptionChange(optionName, value) {
    const name = (optionName || '').toLowerCase();
    const hex  = getHex(value);

    if (name.includes('felgenring') && name.includes('vorne')) {
      sendToViewer('SET_RIM', { target: 'front', hex });
    } else if (name.includes('felgenring') && name.includes('hinten')) {
      sendToViewer('SET_RIM', { target: 'rear', hex });
    } else if (name.includes('naben farbe') && name.includes('vorne')) {
      sendToViewer('SET_HUB', { target: 'front', hex });
    } else if (name.includes('naben farbe') && name.includes('hinten')) {
      sendToViewer('SET_HUB', { target: 'rear', hex });
    } else if (name.includes('veredelung radnabe vorne')) {
      sendToViewer('SET_HUB', { target: 'front', hex });
    } else if (name.includes('veredelung radnabe hinten')) {
      sendToViewer('SET_HUB', { target: 'rear', hex });
    } else if (name.includes('speichen') && !name.includes('nippel')) {
      sendToViewer('SET_SPOKES', { target: 'front', hex });
      sendToViewer('SET_SPOKES', { target: 'rear', hex });
    } else if (name.includes('speichennippel') && name.includes('vorne')) {
      sendToViewer('SET_SPOKES', { target: 'front', hex, nipple: true });
    } else if (name.includes('speichennippel') && name.includes('hinten')) {
      sendToViewer('SET_SPOKES', { target: 'rear', hex, nipple: true });
    }
  }

  // Methode 1: YMQ Custom Event
  document.addEventListener('ymq:option:change', function(e) {
    const { name, value } = e.detail || {};
    handleOptionChange(name, value);
  });

  // Methode 2: MutationObserver auf YMQ Buttons (Fallback)
  function observeYMQ() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          // YMQ markiert aktive Option mit "selected" oder "active" Klasse
        });

        // Klick auf YMQ Pill/Swatch beobachten
        if (m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'aria-checked')) {
          const el = m.target;
          const isSelected = el.classList.contains('selected') || 
                             el.getAttribute('aria-checked') === 'true' ||
                             el.classList.contains('active');
          if (!isSelected) return;

          // Option-Name aus dem Label-Element lesen
          const section = el.closest('[data-option-name], .ymq-option-item, .ymq-option-group');
          const optionName = section?.dataset?.optionName || 
                             section?.querySelector('.ymq-option-label, label')?.textContent || '';
          const value = el.textContent?.trim() || el.dataset?.value || '';

          if (optionName && value) handleOptionChange(optionName, value);
        }
      });
    });

    // YMQ Container beobachten
    const ymqRoot = document.querySelector('#ymq-option-root, .ymq-option-root, [id*="ymq"], [class*="ymq"]');
    if (ymqRoot) {
      observer.observe(ymqRoot, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'], childList: true });
    } else {
      // Fallback: ganzes Dokument
      observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
    }
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  function init() {
    // Nur auf Konfigurator-Produktseite laden
    if (!window.location.pathname.includes('felgensatz-konfigurieren') &&
        !window.location.pathname.includes('products')) return;

    createViewer();
    observeYMQ();

    // YMQ direkt per Click-Event abfangen (sicherste Methode)
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-ymq-option], .ymq-btn, .ymq-swatch, .ymq-pill');
      if (!btn) return;

      const group = btn.closest('[data-ymq-name], .ymq-option-group, .ymq-option-item');
      const optionName = group?.dataset?.ymqName || 
                         group?.querySelector('.ymq-label, .option-label')?.textContent?.trim() || '';
      const value = btn.dataset?.ymqValue || 
                    btn.textContent?.trim() || 
                    btn.getAttribute('aria-label') || '';

      if (optionName && value) handleOptionChange(optionName, value);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
